// NHÓM 3 THAO TÁC XÂY KÊNH (07/10/2026, người dùng duyệt): "Đọc số liệu kênh" (doc_so_lieu_kenh) trên 5 mạng — CHỈ ĐỌC trang của CHÍNH MÌNH
// (không gõ, không bấm nút tương tác; chỉ mở trang + menu ảnh đại diện / menu người dùng để biết nick đang dùng). Bước cuối mang `bao_so_lieu`
// (src/shared/so-lieu-kenh.ts CauHinhBaoSoLieu) → runner gom các biến đã đọc thành RunRecord.soLieuKenh → Boss lưu chuỗi thời gian theo bot + mạng
// (server/src/so-lieu-kenh.ts) và vẽ bảng tăng trưởng trên thẻ bot. Không đọc được chỉ số nào → lần chạy DỪNG có lý do (không gửi bản ghi rỗng).
// Trang đọc thành danh sách MỘT mục (cả trang — như RD_KIEM_BAI_SPEC): mỗi chỉ số là một trường có mac_dinh "" → thiếu thì chỉ số đó vắng, không làm hỏng cả bước.
//
// ĐỐI CHIẾU KHẢO SÁT THẬT 04/10/2026:
//  ĐÃ ĐO: YouTube — menu ảnh đại diện + @handle (L-69); đầu trang kênh có chữ "N người đăng ký" và "N video"; mục video có "N lượt xem" (kenh_minh_video);
//         X — link Hồ sơ a[data-testid=AppTabBar_Profile_Link]; liên kết /following và /verified_followers|/followers trên trang hồ sơ có số;
//         TikTok — liên kết Hồ sơ nav-profile (TT_NICK_SPEC) + danh sách video trang cá nhân (TT_VIDEO_CA_NHAN_SPEC, trường luot_xem = video-views);
//         Reddit — nút mở menu người dùng + liên kết /user/<nick>/ (RD_NICK_SPEC).
//  CHƯA KIỂM TRÊN TRANG THẬT (ghi tại từng hằng): vùng chứa số ở đầu trang kênh YouTube (yt-page-header-renderer yt-content-metadata-view-model);
//    chữ "N bài đăng/posts" ở thanh trên trang hồ sơ X; [data-e2e=followers-count|following-count|likes-count] của TikTok (khảo sát TikTok bị CAPTCHA);
//    liên kết "người theo dõi" / "Đang theo dõi" trên trang cá nhân Facebook; chữ karma trên trang hồ sơ Reddit.
import type { KhoiMau } from "./tu-dung";
import { YT_KENH_VIDEO_SPEC, YT_LAY_KENH_MINH } from "./yt-khoi";
import { TT_NICK_SPEC, TT_VIDEO_CA_NHAN_SPEC } from "./tt-khoi";
import { RD_NICK_SPEC } from "./reddit-khoi";

const TOI_DA_VIDEO = 12; // tổng lượt xem = N video MỚI NHẤT (cố định để chuỗi thời gian so được)
// Số đếm + đơn vị viết tắt (vi/en). Regex của trường chạy trong content (new RegExp, không cờ) — group 1 là chữ số, docSoDem đọc ra số.
const SO = "(\\d[\\d.,]*\\s*(?:N|Tr|K|M|B|k|nghìn|triệu|tỷ)?)";
const truongSo = (sel: string, duoi?: string, alt?: string[]) => ({ sel, attr: "text", regex: duoi ? `${SO}\\s*(?:${duoi})` : SO, mac_dinh: "", ...(alt ? { alt } : {}) });
const trangMotMuc = (describe: string, fields: Record<string, unknown>) => ({ mode: "list", list: { describe, ladder: [{ t: "css", sel: "body" }] }, fields });

const MO_TA = (mang: string, gi: string) =>
  `Đọc số liệu kênh ${mang} CỦA CHÍNH MÌNH (${gi}) — CHỈ ĐỌC, không bấm tương tác, không gõ. Kết quả gửi về Boss để xem tăng trưởng theo ngày trên thẻ bot (nút "Số liệu kênh"). Không đọc được chỉ số nào (chưa đăng nhập / trang đổi giao diện) → dừng có lý do, không gửi số rỗng.`;

// ===================== YOUTUBE =====================
// CHƯA KIỂM: vùng chứa số ở đầu trang kênh (chữ "N người đăng ký • N video" ĐÃ thấy khi khảo sát, vùng chứa chưa đo).
const YT_DAU_KENH = trangMotMuc("số liệu ở đầu trang kênh YouTube của mình (người đăng ký, số video)", {
  nguoi_theo_doi: truongSo("yt-page-header-renderer yt-content-metadata-view-model, #page-header yt-content-metadata-view-model", "người đăng ký|subscribers?", ["#subscriber-count", "yt-page-header-renderer"]),
  so_bai: truongSo("yt-page-header-renderer yt-content-metadata-view-model, #page-header yt-content-metadata-view-model", "video|videos", ["#videos-count", "yt-page-header-renderer"]),
});
const YT_VIDEO_LUOT_XEM = { ...YT_KENH_VIDEO_SPEC, fields: { ...YT_KENH_VIDEO_SPEC.fields, luot_xem: truongSo("yt-content-metadata-view-model", "lượt xem|views?", ["#metadata-line span"]) } };
const YT_SO_LIEU: KhoiMau = {
  ten: "doc_so_lieu_kenh",
  moTa: MO_TA("YouTube", `số người đăng ký, số video, tổng lượt xem ${TOI_DA_VIDEO} video mới nhất`),
  thamSo: [],
  trangThu: "https://www.youtube.com/@<kênh mình>/videos (chữ số đo khảo sát kenh_minh_video 04/10; vùng chứa CHƯA kiểm)",
  yamlSteps: `  - id: mo_trang_sl_yt
    on: web
    do: "mở YouTube để đọc kênh đang dùng"
    expect: "trang YouTube"

  - id: mo_menu_sl_yt
    on: web
    do: "bấm ảnh đại diện kênh (góc trên phải) để xem @handle kênh đang dùng"
    expect: "menu ảnh đại diện mở"
    timeout: 20s

  - id: lay_kenh_sl_yt
    on: web
    extract: "@handle kênh đang đăng nhập (menu ảnh đại diện)"
    into: kenh_sl_yt
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_sl_yt
    on: web
    do: "đóng menu ảnh đại diện (phím Esc)"
    optional: true

  - id: mo_kenh_sl_yt
    on: web
    do: "mở trang Video của kênh {{kenh_sl_yt}}"
    expect: "url chứa /videos"

  - id: doc_dau_kenh_sl_yt
    on: web
    extract: "số người đăng ký và số video ở đầu trang kênh mình"
    into: trang_sl_yt
    timeout: 20s

  - id: doc_video_sl_yt
    on: web
    extract: "lượt xem các video mới nhất của kênh mình"
    into: ds_video_sl_yt
    timeout: 20s
    optional: true

  - id: bao_so_lieu_yt
    template: "{{kenh_sl_yt}}"
    into: tk_sl_yt`,
  learned: {
    mo_trang_sl_yt: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    mo_menu_sl_yt: { actions: [{ kind: "click", target: { describe: "ảnh đại diện kênh (góc trên phải) — chưa đăng nhập YouTube thì không có nút này", ladder: [{ t: "css", sel: "button#avatar-btn" }, { t: "css", sel: "#avatar-btn" }] } }], postcondition: [{ t: "dom_exists", sel: "ytd-multi-page-menu-renderer" }] },
    lay_kenh_sl_yt: YT_LAY_KENH_MINH,
    dong_menu_sl_yt: { actions: [{ kind: "press", key: "Escape" }] },
    mo_kenh_sl_yt: { actions: [{ kind: "navigate", url: "{{goc}}{{kenh_sl_yt}}/videos" }], postcondition: [{ t: "url_contains", s: "{{kenh_sl_yt}}/videos" }] },
    doc_dau_kenh_sl_yt: { extract_spec: YT_DAU_KENH },
    doc_video_sl_yt: { extract_spec: YT_VIDEO_LUOT_XEM, ghi_khi_rong: "kênh chưa có video nào — không có lượt xem để cộng" },
    bao_so_lieu_yt: { bao_so_lieu: { nen_tang: "youtube", tai_khoan: "tk_sl_yt", chi_so: { nguoi_theo_doi: "trang_sl_yt.0.nguoi_theo_doi", so_bai: "trang_sl_yt.0.so_bai" }, tong: { luot_xem: { ds: "ds_video_sl_yt", truong: "luot_xem", toi_da: TOI_DA_VIDEO } } } },
  },
};

// ===================== X =====================
const X_LINK_HO_SO = { describe: "link Hồ sơ của nick đang đăng nhập (thanh bên)", ladder: [
  { t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' },
  { t: "xpath", xpath: '(//a[@data-testid="AppTabBar_Profile_Link"])[1]' },
] };
// ĐÃ ĐO: liên kết /following, /verified_followers|/followers có số. CHƯA KIỂM: chữ "N bài đăng / posts" ở thanh trên cùng của trang hồ sơ.
const X_DAU_HO_SO = trangMotMuc("số liệu ở đầu trang hồ sơ X của mình (người theo dõi, đang theo dõi, số bài)", {
  nguoi_theo_doi: truongSo('[data-testid="primaryColumn"] a[href$="/verified_followers"], [data-testid="primaryColumn"] a[href$="/followers"]'),
  dang_theo_doi: truongSo('[data-testid="primaryColumn"] a[href$="/following"]'),
  so_bai: truongSo('[data-testid="primaryColumn"] h2[role="heading"] ~ div, [data-testid="primaryColumn"] div[dir="ltr"]', "bài đăng|posts?|Bài đăng|Posts?"),
});
const X_SO_LIEU: KhoiMau = {
  ten: "doc_so_lieu_kenh",
  moTa: MO_TA("X", "người theo dõi, đang theo dõi, số bài"),
  thamSo: [],
  trangThu: "https://x.com/<nick mình> (link Hồ sơ + liên kết followers/following đo khảo sát; chữ số bài CHƯA kiểm)",
  yamlSteps: `  - id: mo_trang_sl_x
    on: web
    do: "mở trang chủ X"
    expect: "trang X"

  - id: lay_nick_sl_x
    on: web
    extract: "nick đang đăng nhập (link Hồ sơ ở thanh bên)"
    into: nick_sl_x
    timeout: 15s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: mo_ho_so_sl_x
    on: web
    do: "bấm link Hồ sơ ở thanh bên để mở trang hồ sơ của mình"
    expect: "url chứa {{nick_sl_x}}"

  - id: doc_dau_ho_so_sl_x
    on: web
    extract: "người theo dõi, đang theo dõi, số bài ở đầu trang hồ sơ"
    into: trang_sl_x
    timeout: 20s

  - id: bao_so_lieu_x
    template: "{{nick_sl_x}}"
    into: tk_sl_x`,
  learned: {
    mo_trang_sl_x: { actions: [{ kind: "navigate", url: "{{goc}}home" }] },
    lay_nick_sl_x: { extract_spec: { mode: "single", target: { describe: "link Hồ sơ của nick đang đăng nhập (không có = chưa đăng nhập → dừng)", ladder: [{ t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' }] }, attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" } },
    mo_ho_so_sl_x: { actions: [{ kind: "click", target: X_LINK_HO_SO }], postcondition: [{ t: "url_contains", s: "{{nick_sl_x}}" }] },
    doc_dau_ho_so_sl_x: { extract_spec: X_DAU_HO_SO },
    bao_so_lieu_x: { bao_so_lieu: { nen_tang: "x", tai_khoan: "tk_sl_x", chi_so: { nguoi_theo_doi: "trang_sl_x.0.nguoi_theo_doi", dang_theo_doi: "trang_sl_x.0.dang_theo_doi", so_bai: "trang_sl_x.0.so_bai" } } },
  },
};

// ===================== TIKTOK =====================
// CHƯA KIỂM: [data-e2e="followers-count" | "following-count" | "likes-count"] ở đầu trang cá nhân (khảo sát TikTok bị CAPTCHA).
const TT_DAU_HO_SO = trangMotMuc("số liệu ở đầu trang cá nhân TikTok của mình (follower, following, lượt thích)", {
  nguoi_theo_doi: truongSo('[data-e2e="followers-count"]'),
  dang_theo_doi: truongSo('[data-e2e="following-count"]'),
  luot_thich: truongSo('[data-e2e="likes-count"]'),
});
const TT_SO_LIEU: KhoiMau = {
  ten: "doc_so_lieu_kenh",
  moTa: MO_TA("TikTok", `follower, đang follow, tổng lượt thích, tổng lượt xem ${TOI_DA_VIDEO} video đầu trang cá nhân`),
  thamSo: [],
  trangThu: "https://www.tiktok.com/@<nick mình> (nav-profile + danh sách video đo khảo sát; ô số đầu trang CHƯA kiểm — CAPTCHA)",
  yamlSteps: `  - id: mo_trang_chu_sl_tt
    on: web
    do: "mở TikTok để đọc nick đang dùng"
    expect: "trang TikTok"

  - id: lay_nick_sl_tt
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ ở thanh bên)"
    into: nick_sl_tt
    timeout: 15s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: mo_ho_so_sl_tt
    on: web
    do: "mở trang cá nhân @{{nick_sl_tt}}"
    expect: "url chứa /@{{nick_sl_tt}}"

  - id: doc_dau_ho_so_sl_tt
    on: web
    extract: "follower, following, lượt thích ở đầu trang cá nhân"
    into: trang_sl_tt
    timeout: 20s

  - id: doc_video_sl_tt
    on: web
    extract: "lượt xem các video trên trang cá nhân của mình"
    into: ds_video_sl_tt
    timeout: 20s
    optional: true

  - id: bao_so_lieu_tt
    template: "{{nick_sl_tt}}"
    into: tk_sl_tt`,
  learned: {
    mo_trang_chu_sl_tt: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    lay_nick_sl_tt: { extract_spec: TT_NICK_SPEC },
    mo_ho_so_sl_tt: { actions: [{ kind: "navigate", url: "{{goc}}@{{nick_sl_tt}}" }], postcondition: [{ t: "url_contains", s: "/@{{nick_sl_tt}}" }] },
    doc_dau_ho_so_sl_tt: { extract_spec: TT_DAU_HO_SO },
    doc_video_sl_tt: { extract_spec: TT_VIDEO_CA_NHAN_SPEC, ghi_khi_rong: "trang cá nhân chưa có video nào — không có lượt xem để cộng" },
    bao_so_lieu_tt: { bao_so_lieu: { nen_tang: "tiktok", tai_khoan: "tk_sl_tt", chi_so: { nguoi_theo_doi: "trang_sl_tt.0.nguoi_theo_doi", dang_theo_doi: "trang_sl_tt.0.dang_theo_doi", luot_thich: "trang_sl_tt.0.luot_thich" }, tong: { luot_xem: { ds: "ds_video_sl_tt", truong: "luot_xem", toi_da: TOI_DA_VIDEO } } } },
  },
};

// ===================== FACEBOOK =====================
// CHƯA KIỂM: liên kết "N người theo dõi" (href chứa followers) và "Đang theo dõi N" (href chứa following) ở đầu trang cá nhân; tên ở h1.
const FB_DAU_TRANG = trangMotMuc("số liệu ở đầu trang cá nhân Facebook của mình (tên, người theo dõi, đang theo dõi)", {
  ten: { sel: 'div[role="main"] h1', attr: "text", mac_dinh: "" },
  nguoi_theo_doi: truongSo('div[role="main"] a[href*="followers"]'),
  dang_theo_doi: truongSo('div[role="main"] a[href*="following"]'),
});
const FB_SO_LIEU: KhoiMau = {
  ten: "doc_so_lieu_kenh",
  moTa: MO_TA("Facebook", "người theo dõi, đang theo dõi của trang cá nhân"),
  thamSo: [],
  trangThu: "https://www.facebook.com/me/ (liên kết người theo dõi / đang theo dõi CHƯA kiểm)",
  yamlSteps: `  - id: mo_trang_ca_nhan_sl_fb
    on: web
    do: "mở trang cá nhân của mình"
    expect: "trang cá nhân"

  - id: doc_dau_trang_sl_fb
    on: web
    extract: "tên, số người theo dõi, số đang theo dõi ở đầu trang cá nhân"
    into: trang_sl_fb
    timeout: 20s

  - id: bao_so_lieu_fb
    template: "trang cá nhân"
    into: noi_sl_fb`,
  learned: {
    mo_trang_ca_nhan_sl_fb: { actions: [{ kind: "navigate", url: "{{goc}}me/" }] },
    doc_dau_trang_sl_fb: { extract_spec: FB_DAU_TRANG },
    bao_so_lieu_fb: { bao_so_lieu: { nen_tang: "facebook", tai_khoan: "trang_sl_fb.0.ten", chi_so: { nguoi_theo_doi: "trang_sl_fb.0.nguoi_theo_doi", dang_theo_doi: "trang_sl_fb.0.dang_theo_doi" } } },
  },
};

// ===================== REDDIT =====================
// CHƯA KIỂM: chữ karma trên trang hồ sơ (/user/<nick>/) — số đứng trước HOẶC sau chữ "karma"; "N followers".
const RD_HO_SO = trangMotMuc("số liệu trên trang hồ sơ Reddit của mình (karma, người theo dõi)", {
  karma: { sel: 'aside, #right-sidebar-container, [slot="sidebar"], main', attr: "text", regex: `${SO}\\s*(?:karma|Karma)|(?:karma|Karma)\\s*(\\d[\\d.,]*\\s*(?:K|M|B|k)?)`, mac_dinh: "" },
  nguoi_theo_doi: truongSo('aside, #right-sidebar-container, [slot="sidebar"]', "followers?|người theo dõi"),
});
const RD_SO_LIEU: KhoiMau = {
  ten: "doc_so_lieu_kenh",
  moTa: MO_TA("Reddit", "karma, người theo dõi của nick"),
  thamSo: [],
  trangThu: "https://www.reddit.com/user/<nick mình>/ (menu người dùng đo khảo sát; chữ karma CHƯA kiểm)",
  yamlSteps: `  - id: mo_trang_sl_rd
    on: web
    do: "mở Reddit"
    expect: "trang Reddit"

  - id: mo_menu_sl_rd
    on: web
    do: "bấm nút mở menu người dùng (góc trên phải) để đọc nick đang dùng"
    expect: "menu người dùng mở"
    timeout: 20s

  - id: lay_nick_sl_rd
    on: web
    extract: "tên nick Reddit đang đăng nhập (menu người dùng)"
    into: nick_sl_rd
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_sl_rd
    on: web
    do: "đóng menu người dùng (phím Esc)"
    optional: true

  - id: mo_ho_so_sl_rd
    on: web
    do: "mở trang hồ sơ u/{{nick_sl_rd}}"
    expect: "url chứa /user/{{nick_sl_rd}}"

  - id: doc_ho_so_sl_rd
    on: web
    extract: "karma và số người theo dõi trên trang hồ sơ"
    into: trang_sl_rd
    timeout: 20s

  - id: bao_so_lieu_rd
    template: "{{nick_sl_rd}}"
    into: tk_sl_rd`,
  learned: {
    mo_trang_sl_rd: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    mo_menu_sl_rd: { actions: [{ kind: "click", target: { describe: "nút mở menu người dùng Reddit (góc trên phải) — chưa đăng nhập thì không có", ladder: [
      { t: "css", sel: "#expand-user-drawer-button" },
      { t: "css", sel: 'button[aria-label="Expand user menu"]' },
    ] } }], postcondition: [{ t: "dom_exists", sel: "#user-drawer-content" }] },
    lay_nick_sl_rd: { extract_spec: RD_NICK_SPEC },
    dong_menu_sl_rd: { actions: [{ kind: "press", key: "Escape" }] },
    mo_ho_so_sl_rd: { actions: [{ kind: "navigate", url: "{{goc}}user/{{nick_sl_rd}}/" }], postcondition: [{ t: "url_contains", s: "/user/{{nick_sl_rd}}" }] },
    doc_ho_so_sl_rd: { extract_spec: RD_HO_SO },
    bao_so_lieu_rd: { bao_so_lieu: { nen_tang: "reddit", tai_khoan: "tk_sl_rd", chi_so: { karma: "trang_sl_rd.0.karma", nguoi_theo_doi: "trang_sl_rd.0.nguoi_theo_doi" } } },
  },
};

/** Khối nhóm 3 theo mạng — nối vào thư viện ở src/shared/khoi-thu-vien.ts. */
export const KHOI_SO_LIEU: Readonly<Record<"facebook" | "x" | "tiktok" | "youtube" | "reddit", KhoiMau[]>> = {
  facebook: [FB_SO_LIEU],
  x: [X_SO_LIEU],
  tiktok: [TT_SO_LIEU],
  youtube: [YT_SO_LIEU],
  reddit: [RD_SO_LIEU],
};

const HT = (gi: string) => ({ bieuTuong: "📊", tenNgan: "Đọc số liệu kênh", mauMoTa: `Đọc số liệu kênh của mình (${gi}) — chỉ đọc, gửi về Boss để xem tăng trưởng` });
export const HIEN_THI_SO_LIEU: Readonly<Record<string, { bieuTuong: string; tenNgan: string; mauMoTa: string }>> = {
  "youtube/doc_so_lieu_kenh": HT("người đăng ký, số video, lượt xem video mới"),
  "x/doc_so_lieu_kenh": HT("người theo dõi, đang theo dõi, số bài"),
  "tiktok/doc_so_lieu_kenh": HT("follower, following, lượt thích, lượt xem video mới"),
  "facebook/doc_so_lieu_kenh": HT("người theo dõi, đang theo dõi"),
  "reddit/doc_so_lieu_kenh": HT("karma, người theo dõi"),
};
